/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { QueryStringComparisonOperator, QueryComparisonOperator } from './api-types';
import { encodeFieldName, encodeStringLiteral, mapQueryStringComparisonOperator } from './api-utilities';

export interface IQueryStringFilterOptions {
    ignoreNullValue: boolean;
    negate: boolean;
    operator: QueryStringComparisonOperator;
}

export class ApiQueryStringFilter implements IApiQueryFilter {

    constructor(public field: string, public value: string | null, public options: IQueryStringFilterOptions) { }

    public toString(): string {
        const operation = mapQueryStringComparisonOperator(this.options.operator, this.options.negate);
        const encodedField = encodeFieldName(this.field);
        const encodedValue = encodeStringLiteral(this.value);

        return operation.buildExpression(encodedField, encodedValue);
    }

}
